import { Component, Injectable, OnInit, TemplateRef, ViewChild, ElementRef, HostListener,AfterViewInit } from '@angular/core';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { BsModalService, Utils } from 'ngx-bootstrap';
import { CalendarComponent } from 'ng-fullcalendar';
import { Options } from 'fullcalendar';

import * as _ from 'lodash';
import { IvrService } from '../../../../../common/services/Ivr.service';
import { UploadService } from '../../../../../common/services/Upload.service';
import { CommonService } from '../../../../../common/services/Common.service';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { TimeService } from '../../../../../common/services/Time.service';
import { UtilityService } from 'app/common/services/Utility.service';


declare var $: any;

@Component({
    moduleId: module.id,
    selector: "worktime",
    templateUrl: './time.component.html',
    styleUrls: ['./time.css'],
    providers: [BsModalService, TimeService, UtilityService]
})

@Injectable()
export class TimeComponent implements OnInit {
    calendarOptions: Options;
    @ViewChild(CalendarComponent) ucCalendar: CalendarComponent;
    @ViewChild('templateEvent') templateEvent: ElementRef;

    public message: { class: string, content: string } = null;
    public listSchedule: any = [];
    public model: any = {};
    public modelEvent: any = {};
    public modalRef: any = {};
    public modalRef2: any = {};
    public user: any;
    public id_delete: number;
    public typeModal: string = 'add';
    public current_schedule_id: any;
    public current_schedule: any;
    public limit:number = 15;
    public isLoad:boolean = false;
    public totalSchedule:number = 0;
    public keyword:string = "";
    public listSchedule_page_devide:any = [];
    public listPeriod: any = [];
    totalItem: any = 0;
    totalPage: any = 0;
    public page_size: number = 10;
    public currentPage: number = 1;

    public displayEvent: any;

    constructor(
        private timeService: TimeService,
        private modalService: BsModalService,
        private toastr: ToastrService) {

        this.user = JSON.parse(localStorage.getItem('User'));
    }

    ngOnInit() {
        this.calendarOptions = {
            editable: true,
            eventLimit: false,
            header: {
                left: 'prev,next today',
                center: 'title',
                right: 'month,agendaWeek,agendaDay,listMonth'
            },
            selectable: true,
            businessHours: {
                // days of week. an array of zero-based day of week integers (0=Sunday)
                dow: [1, 2, 3, 4, 5, 6], // Monday - Thursday
                start: '8:00', // a start time (10am in this example)
                end: '18:00', // an end time (6pm in this example)
            },
            defaultView: "month",
            events: [],
            eventTextColor: "#fff",
            timeFormat: 'H(:mm)',
            displayEventTime: true
        };
        this.loadData()
    }

    ngAfterViewInit() {
        setTimeout(function () {
        $('.fc-prev-button').removeClass('fc-prev-button');
        $('.fc-next-button').removeClass('fc-next-button');
        }, 500);
    }

    detailSchedule(schedule, force = false) {
        // console.log(schedule);
        // console.log()
        // if(schedule.TIME_SCHEDULE_ID != this.current_schedule_id || force) {
            var request:any = {};
            request.offset = this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
            request.limit = this.page_size;
            this.current_schedule_id = schedule.TIME_SCHEDULE_ID;
            request.TIME_SCHEDULE_ID = this.current_schedule_id;
            this.current_schedule = schedule;
            let start = moment(schedule.START_TIME);
            let end = moment(schedule.END_TIME);

            let day_of_week = schedule.DAY_OF_WEEK ? schedule.DAY_OF_WEEK.split(',') : [];
            let events = [];
            // let days = [];

            // while(start <= end) {
            //     if(day_of_week.length > 0) {
            //         let dayInWeek = start.day() + 1;
            //         if(day_of_week.indexOf(dayInWeek.toString()) != -1) {
            //             events.push({
            //                 start: start.format('YYYY-MM-DD'),
            //                 rendering: "background"
            //             })
            //             days.push(start.format('YYYY-MM-DD'));
            //         }
            //     }else {
            //         events.push({
            //             start: start.format('YYYY-MM-DD'),
            //             rendering: "background"
            //         })
            //         days.push(start.format('YYYY-MM-DD'));
            //     }
            //     start = start.add(1,'days');
            // }

            this.timeService.listPeriod(request).subscribe(res => {
                if(!res.erro && res.status == 200) {
                    this.listPeriod = res.data.data;
                    this.totalItem = res.data.total;
                    var pageString = (this.totalItem / this.page_size).toString();
                    var pageSplit = pageString.split('.');
                    var last: any;
                    var totalpage = parseInt(pageSplit[0]);
                    if (pageSplit.length > 1) {
                        last = pageSplit[1];
                        if (parseInt(last) > 0) {
                            totalpage++
                        }
                    }
                    this.totalPage = totalpage;
                    this.listPeriod.forEach(e => {
                        if(e.DATE_FROM){
                            e.DATE_FROM_VN = moment(e.DATE_FROM).format("DD-MM-YYYY");
                        }
                        if(e.DATE_TO){
                            e.DATE_TO_VN = moment(e.DATE_TO).format("DD-MM-YYYY");
                        }
                        if(e.DAY_OF_WEEK){
                            let DAY_OF_WEEK_TRANSLATE = '';
                            let tmp = e.DAY_OF_WEEK.split(',');
                            tmp.forEach(m => {
                                if(m == 0){
                                    DAY_OF_WEEK_TRANSLATE += 'Chủ nhật, ';
                                } else if (m == 1){
                                    DAY_OF_WEEK_TRANSLATE += 'Thứ hai, ';
                                } else if (m == 2){
                                    DAY_OF_WEEK_TRANSLATE += 'Thứ ba, ';
                                } else if (m == 3){
                                    DAY_OF_WEEK_TRANSLATE += 'Thứ tư, ';
                                } else if (m == 4){
                                    DAY_OF_WEEK_TRANSLATE += 'Thứ năm, ';
                                } else if (m == 5){
                                    DAY_OF_WEEK_TRANSLATE += 'Thứ sáu, ';
                                } else if (m == 6){
                                    DAY_OF_WEEK_TRANSLATE += 'Thứ bảy, ';
                                }
                            })
                            DAY_OF_WEEK_TRANSLATE = UtilityService.trimChar(DAY_OF_WEEK_TRANSLATE.trim(), ",");
                            e.DAY_OF_WEEK_TRANSLATE = DAY_OF_WEEK_TRANSLATE;
                        }
                        
                    })
                    // days.forEach(d => {
                    //     let str_day = d;
                    //     this.listPeriod.forEach(e => {
                    //         let time_start  = str_day+' '+e.HFROM;
                    //         let time_end = str_day + ' '+e.HTO;
                    //         let title = e.TIME_PERIOD_NAME
                    //         events.push({
                    //             title: title,
                    //             start: time_start,
                    //             end: time_end,
                    //             id: e.id
                    //         })
                    //     });
                    // });
                }
                // this.calendarOptions = {
                //     editable: true,
                //     eventLimit: false,
                //     header: {
                //         left: 'prev,next today',
                //         center: 'title',
                //         right: 'month,agendaWeek,agendaDay,listMonth'
                //     },
                //     selectable: true,
                //     businessHours: {
                //         // days of week. an array of zero-based day of week integers (0=Sunday)
                //         dow: [1, 2, 3, 4, 5, 6], // Monday - Thursday
                //         start: '8:00', // a start time (10am in this example)
                //         end: '18:00', // an end time (6pm in this example)
                //     },
                //     defaultView: "month",
                //     events:events,
                //     eventTextColor: "#fff",
                //     timeFormat: 'H(:mm)',
                //     displayEventTime: true
                // };
            })

        // }
    }

    loadData() {
        let request = {};
        request['limit'] = this.limit;
        request['keyword'] = this.keyword;
        this.timeService.listSchedule(request).subscribe(res => {
            if (res.status == 200 && !res.error) {
                this.listSchedule = res.data.data;
                this.isLoad = false;
                this.totalSchedule = res.data.total.total;
                if(this.listSchedule.length > 0) {
                    this.detailSchedule(this.listSchedule[0]);
                }
                this.listSchedule_page_devide = this.listSchedule.slice(0, this.limit);
            }
        })
    }

    openModelEvent(template:TemplateRef<any>) {
        // let currentDay = new Date();
        // let lastDayOfMonth = new Date(currentDay.getFullYear(), currentDay.getMonth() + 1, 0, 23, 59, 59);
        // this.modelEvent = {TIME_TYPE: 0, DATE_FROM: moment(currentDay).format("YYYY-MM-DD"), DATE_TO: moment(lastDayOfMonth).format("YYYY-MM-DD")};
        this.modelEvent = {TIME_TYPE: 0};
        this.message = null;
        this.typeModal = 'add';
        let config = {
            backdrop:true,
            ignoreBackdropClick: true,
            class: 'modal-md',
            keyboard: false
        }
        this.modalRef = this.modalService.show(template, config);
        // (<any>$('.timepicker')).clockpicker();
        this.modelEvent.HFROM = "00:00";
        this.modelEvent.HTO = "23:59";
    }

    openEditModelEvent(template:TemplateRef<any>, event) {
        // this.modelEvent =  _.assign({}, event);
        this.message = null;
        this.typeModal = 'edit';
        let config = {
            backdrop:true,
            ignoreBackdropClick: true,
            class: 'modal-md',
            keyboard: false
        }
        this.modalRef = this.modalService.show(template, config);
        if (event.id) {
            this.timeService.findPeriod(event.id).toPromise().then(rs => {
                this.modelEvent = rs.data;
                if(this.modelEvent.TIME_TYPE == 0){
                    this.modelEvent.DATE_FROM = moment(this.modelEvent.DATE_FROM).format("YYYY-MM-DD");
                    this.modelEvent.DATE_TO = moment(this.modelEvent.DATE_TO).format("YYYY-MM-DD");
                }
                let DAY_OF_WEEK = this.modelEvent.DAY_OF_WEEK ? this.modelEvent.DAY_OF_WEEK.split(',') : [];
                let check = false;
                DAY_OF_WEEK.forEach(e => {
                    switch(parseInt(e)) {
                        case 1: {
                            this.modelEvent['t2']  = true;
                            check = true;
                            break;
                        }
                        case 2: {
                            this.modelEvent['t3']  = true;
                            check = true;
                            break;
                        }
                        case 3: {
                            this.modelEvent['t4']  = true;
                            check = true;
                            break;
                        }
                        case 4: {
                            this.modelEvent['t5']  = true;
                            check = true;
                            break;
                        }
                        case 5: {
                            this.modelEvent['t6']  = true;
                            check = true;
                            break;
                        }
                        case 6: {
                            this.modelEvent['t7']  = true;
                            check = true;
                            break;
                        }
                        case 0: {
                            this.modelEvent['cn']  = true;
                            check = true;
                            break;
                        }
                        default: break;
                    }
                });

                if(check) $('#btnSetupWeek').trigger('click');
            })
        }
        // (<any>$('.timepicker')).clockpicker();
    }

    saveEvent() {
        console.log(this.modelEvent);
        this.modelEvent.HFROM = $('#HFROM').val() ? $('#HFROM').val() : this.modelEvent.HFROM;
        this.modelEvent.HTO = $('#HTO').val() ? $('#HTO').val() : this.modelEvent.HTO;
        this.modelEvent.ROUTE_TYPE = $('#ROUTE_TYPE').val() ? $('#ROUTE_TYPE').val() : this.modelEvent.ROUTE_TYPE;
        let message = null;
        let DAY_OF_WEEK = []
        if(this.modelEvent.t2) DAY_OF_WEEK.push(1);
        if(this.modelEvent.t3) DAY_OF_WEEK.push(2);
        if(this.modelEvent.t4) DAY_OF_WEEK.push(3);
        if(this.modelEvent.t5) DAY_OF_WEEK.push(4);
        if(this.modelEvent.t6) DAY_OF_WEEK.push(5);
        if(this.modelEvent.t7) DAY_OF_WEEK.push(6);
        if(this.modelEvent.cn) DAY_OF_WEEK.push(0);
        if(!this.modelEvent.TIME_PERIOD_NAME || this.modelEvent.TIME_PERIOD_NAME.trim() == '') {
            message = { class: "alert dark alert-danger", content: "Tên sự kiện không được bỏ trống !" };
        }else if(!this.modelEvent.HFROM || this.modelEvent.HFROM == '') {
            message = { class: "alert dark alert-danger", content: "Giờ bắt đầu không được bỏ trống !" };
        }else if(!this.modelEvent.HTO || this.modelEvent.HTO == '') {
            message = { class: "alert dark alert-danger", content: "Giờ kết thúc không được bỏ trống !" };
        } else if(!moment(this.modelEvent.HFROM, "HH:mm").isBefore(moment(this.modelEvent.HTO, "HH:mm"))){
            message = { class: "alert dark alert-danger", content: "Giờ bắt đầu phải nhỏ hơn giờ kết thúc" };
        }
        else if(this.modelEvent.TIME_TYPE == 1 && DAY_OF_WEEK.length == 0){
            message = { class: "alert dark alert-danger", content: "Chưa thiết lập các ngày trong tuần" };
        }
        else if(this.modelEvent.TIME_TYPE == 0 && !this.modelEvent.DATE_FROM){
            message = { class: "alert dark alert-danger", content: "Ngày bắt đầu không hợp lệ" };
        }
        else if(this.modelEvent.TIME_TYPE == 0 && !this.modelEvent.DATE_TO){
            message = { class: "alert dark alert-danger", content: "Ngày kết thúc không hợp lệ" };
        }
        else if(moment(this.modelEvent.DATE_TO, "YYYY-MM-DD 00:00:00").isBefore(moment(this.modelEvent.DATE_FROM, "YYYY-MM-DD 23:59:59"))){
            message = { class: "alert dark alert-danger", content: "Ngày kết thúc không được sớm hơn ngày bắt đầu" };
        }
        // }else if(!this.modelEvent.ROUTE_TYPE) {
        //     this.message = { class: "alert dark alert-danger", content: "Loại chuyển hướng không được bỏ trống !" };
        if (message) {
            this.message = message;
            // this.toastr.error(message.content, '', {
            //     timeOut: 4000,
            //     positionClass: 'toast-bottom-right'
            // });
        } else {
            this.modelEvent.TIME_PERIOD_NAME  = this.modelEvent.TIME_PERIOD_NAME.trim();
            this.modelEvent.HFROM = this.modelEvent.HFROM.trim();
            this.modelEvent.HTO = this.modelEvent.HTO.trim(); 
            // let numberFrom = parseInt(this.modelEvent.HFROM.replace(':',''))
            // let numberTo = parseInt(this.modelEvent.HTO.replace(':',''));
            // let diff = moment(this.modelEvent.HFROM, "HH:mm").isBefore(moment(this.modelEvent.HTO, "HH:mm"));
            // if(!diff) {
            //     this.toastr.error("Giờ bắt đầu phải nhỏ hơn giờ kết thúc !", '', {
            //         timeOut: 4000,
            //         positionClass: 'toast-bottom-right'
            //     });
            // } else {
                let payload =  {
                    TIME_PERIOD_NAME : this.modelEvent.TIME_PERIOD_NAME.trim(),
                    HFROM : this.modelEvent.HFROM.trim(),
                    HTO : this.modelEvent.HTO.trim(),
                    // ROUTE_TYPE: this.modelEvent.ROUTE_TYPE,
                    // ROUTE_TO : this.modelEvent.ROUTE_TO,
                    TIME_SCHEDULE_ID : this.current_schedule_id,
                    TIME_TYPE: this.modelEvent.TIME_TYPE,
                    DAY_OF_WEEK: DAY_OF_WEEK.join(','),
                    DATE_FROM: this.modelEvent.DATE_FROM,
                    DATE_TO: this.modelEvent.DATE_TO,
                }
                if(this.typeModal == 'edit') {
                    let period_id = parseInt(this.modelEvent.id);
                    this.timeService.updatePeriod(period_id, payload).subscribe(res => {
                        if (res) {
                            let error = res.error;
                            if (error) {
                                this.message = { class: "alert dark alert-danger", content: "Cập nhật không thành công" };
                                this.toastr.error('Cập nhật thất bại', '', {
                                    timeOut: 4000,
                                    positionClass: 'toast-bottom-right'
                                });
                            } else {
                                this.message = { class: "alert dark alert-success", content: "Cập nhật thành công" };
                                this.toastr.success('Cập nhật thành công', '', {
                                    timeOut: 4000,
                                    positionClass: 'toast-bottom-right'
                                });
                                this.detailSchedule(this.current_schedule, true);
                                this.modalRef.hide();
                            }
                        }
                    }, error => {
                        this.message = { class: "alert dark alert-danger", content: error.message };
                    });
                }else {
                    this.timeService.createPeriod(payload).subscribe(res => {
                        if (res) {
                            let error = res.error;
                            if (error) {
                                this.message = { class: "alert dark alert-danger", content: "Thêm mới không thành công" };
                                this.toastr.error('Thêm mới thất bại', '', {
                                    timeOut: 4000,
                                    positionClass: 'toast-bottom-right'
                                });
                            } else {
                                this.message = { class: "alert dark alert-success", content: "Thêm mới thành công" };
                                this.toastr.success('Thêm mới thành công', '', {
                                    timeOut: 4000,
                                    positionClass: 'toast-bottom-right'
                                });
        
                                this.detailSchedule(this.current_schedule, true);
                                this.modalRef.hide();
                            }
                        }
                    }, error => {
                        this.message = { class: "alert dark alert-danger", content: error.message };
                    });
                }
            // }
        }
    }
    openModal(template: TemplateRef<any>, id?: any) {
        this.message = null;
        let config = {
            backdrop:true,
            ignoreBackdropClick: true,
            keyboard: false
        }
        this.modalRef = this.modalService.show(template, config);
        // (<any>$('.input-date')).datepicker({ format: 'dd/MM/yyyy' });
        
        this.model = {};
        this.typeModal = id ? 'edit' : 'add'

        if (id) {
            this.timeService.findSchedule(id).toPromise().then(rs => {
                this.model = rs.data;
                // let DAY_OF_WEEK = this.model.DAY_OF_WEEK ? this.model.DAY_OF_WEEK.split(',') : [];
                // let check = false;
                // DAY_OF_WEEK.forEach(e => {
                //     switch(parseInt(e)) {
                //         case 2: {
                //             this.model['t2']  = true;
                //             check = true;
                //             break;
                //         }
                //         case 3: {
                //             this.model['t3']  = true;
                //             check = true;
                //             break;
                //         }
                //         case 4: {
                //             this.model['t4']  = true;
                //             check = true;
                //             break;
                //         }
                //         case 5: {
                //             this.model['t5']  = true;
                //             check = true;
                //             break;
                //         }
                //         case 6: {
                //             this.model['t6']  = true;
                //             check = true;
                //             break;
                //         }
                //         case 7: {
                //             this.model['t7']  = true;
                //             check = true;
                //             break;
                //         }
                //         case 1: {
                //             this.model['cn']  = true;
                //             check = true;
                //             break;
                //         }
                //         default: break;
                //     }
                // });

                // this.model['START_TIME'] = moment(this.model['START_TIME']).format('YYYY-MM-DD');
                // this.model['END_TIME'] = moment(this.model['END_TIME']).format('YYYY-MM-DD');
                // if(check) $('#btnSetupWeek').trigger('click');
            })
        }
    }

    saveSchedule() {
        // this.model.START_TIME = $('#START_TIME').val() ? $('#START_TIME').val() : this.model.START_TIME;
        // this.model.END_TIME  = $('#END_TIME').val() ? $('#END_TIME').val() : this.model.END_TIME ;
        // let DAY_OF_WEEK = []
        // if(this.model.t2) DAY_OF_WEEK.push(1);
        // if(this.model.t3) DAY_OF_WEEK.push(2);
        // if(this.model.t4) DAY_OF_WEEK.push(3);
        // if(this.model.t5) DAY_OF_WEEK.push(4);
        // if(this.model.t6) DAY_OF_WEEK.push(5);
        // if(this.model.t7) DAY_OF_WEEK.push(6);
        // if(this.model.cn) DAY_OF_WEEK.push(0);
        if (!this.model.TIME_SCHEDULE_NAME || (this.model.TIME_SCHEDULE_NAME && this.model.TIME_SCHEDULE_NAME.trim() == "")) {
            this.message = { class: "alert dark alert-danger", content: "Tên kế hoạch không được bỏ trống !" };
            setTimeout(() => {this.message = null;}, 3000);
        }
        // else if (!this.model.START_TIME && !this.model.SCHEDULE_TYPE) {
        //     this.message = { class: "alert dark alert-danger", content: "Thời gian bắt đầu không được bỏ trống" };
        //     setTimeout(() => {this.message = null;}, 3000);
        // } else if(!this.model.END_TIME && !this.model.SCHEDULE_TYPE) {
        //     this.message = { class: "alert dark alert-danger", content: "Thời gian kết thúc không được bỏ trống" };
        //     setTimeout(() => {this.message = null;}, 3000);
        // } 
        // else if(this.model.SCHEDULE_TYPE && DAY_OF_WEEK.length == 0){
        //     this.message = { class: "alert dark alert-danger", content: "Chưa thiết lập các ngày trong tuần" };
        //     setTimeout(() => {this.message = null;}, 3000);
        // }
        //  else if(moment(this.model.START_TIME).format('YYYY-MM-DD') > moment(this.model.END_TIME).format('YYYY-MM-DD')){
        //     this.message = { class: "alert dark alert-danger", content: "Thời gian kết thúc không được sớm hơn thời gian bắt đầu" };
        //     setTimeout(() => {this.message = null;}, 3000);
        // }
        else {
            let payload;
            if(this.model.SCHEDULE_TYPE){
                payload = {
                    TIME_SCHEDULE_NAME : this.model.TIME_SCHEDULE_NAME.trim(),
                    // START_TIME: moment(this.model.START_TIME).format('YYYY-MM-DD'), //moment(this.model.START_TIME,'DD/MM/YYYY'),
                    // END_TIME: moment(this.model.END_TIME).format('YYYY-MM-DD'), //moment(this.model.END_TIME,'DD/MM/YYYYY'),
                    SCHEDULE_TYPE: this.model.SCHEDULE_TYPE ? this.model.SCHEDULE_TYPE : 0,
                    // DAY_OF_WEEK: DAY_OF_WEEK.join(',')
                }
            } else {
                payload = {
                    TIME_SCHEDULE_NAME : this.model.TIME_SCHEDULE_NAME.trim(),
                    // START_TIME: moment(this.model.START_TIME).format('YYYY-MM-DD'), //moment(this.model.START_TIME,'DD/MM/YYYY'),
                    // END_TIME: moment(this.model.END_TIME).format('YYYY-MM-DD'), //moment(this.model.END_TIME,'DD/MM/YYYYY'),
                    SCHEDULE_TYPE: this.model.SCHEDULE_TYPE ? this.model.SCHEDULE_TYPE : 0
                }
            }
            
            
            

            // if(DAY_OF_WEEK.length > 0) payload['SCHEDULE_TYPE'] = 1;
            // else payload['SCHEDULE_TYPE'] = 3;
            if(this.typeModal == 'edit') {
                let schedule_id = parseInt(this.model.TIME_SCHEDULE_ID);
                this.timeService.updateSchedule(schedule_id, payload).subscribe(res => {
                    if (res) {
                        let error = res.error;
                        if (error) {
                            this.message = { class: "alert dark alert-danger", content: "Cập nhật không thành công" };
                            this.toastr.error('Cập nhật thất bại', '', {
                                timeOut: 4000,
                                positionClass: 'toast-bottom-right'
                            });
                        } else {
                            this.message = { class: "alert dark alert-success", content: "Cập nhật thành công" };
                            this.toastr.success('Cập nhật thành công', '', {
                                timeOut: 4000,
                                positionClass: 'toast-bottom-right'
                            });
                            this.loadData();
                            this.modalRef.hide();
                        }
                    }
                }, error => {
                    this.message = { class: "alert dark alert-danger", content: error.message };
                    setTimeout(() => {
                        this.message = null;
                    }, 3000);
                });
            }else {
                this.timeService.createSchedule(payload).subscribe(res => {
                    if (res) {
                        let error = res.error;
                        if (error) {
                            this.message = { class: "alert dark alert-danger", content: "Thêm mới không thành công" };
                            this.toastr.error('Thêm mới thất bại', '', {
                                timeOut: 4000,
                                positionClass: 'toast-bottom-right'
                            });
                        } else {
                            this.message = { class: "alert dark alert-success", content: "Thêm mới thành công" };
                            this.toastr.success('Thêm mới thành công', '', {
                                timeOut: 4000,
                                positionClass: 'toast-bottom-right'
                            });
    
                            this.loadData();
                            this.modalRef.hide();
                        }
                    }
                }, error => {
                    this.message = { class: "alert dark alert-danger", content: error.message };
                    setTimeout(() => {
                        this.message = null;
                    }, 3000);
                });
            }
        }
    }

    openConfirmDeleteEvent(template: TemplateRef<any>, id) {
        this.id_delete = id;
        // this.modalRef2 = this.modalService.show(template);
        var y = confirm("Bạn có muốn xóa sự kiện này không?");
        if(y){
            this.submitDeleteEvent(id);
        }
    }

    submitDeleteEvent(event_id) {
        this.timeService.deletePeriod(event_id).subscribe(res => {
            if (res) {
                let error = res.error;
                if (error) {
                    this.toastr.error('Xóa không thành công', '', {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                    });
                } else {
                    this.toastr.success('Xóa thành công', '', {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                    });
                    this.detailSchedule(this.current_schedule, true);
                    this.modalRef.hide();
                }
            }
        }, error => {
            this.message = { class: "alert dark alert-danger", content: error.message };
        });
    }

    openConfirmDelete(template: TemplateRef<any>, id) {
        this.id_delete = id;
        // this.modalRef2 = this.modalService.show(template);
        var y = confirm("Bạn có muốn xóa kế hoạch này không?");
        if(y){
            this.submitDelete();
        }
    }

    submitDelete() {
        this.timeService.deleteSchedule(this.id_delete).subscribe(res => {
            if (res) {
                let error = res.error;
                if (error) {
                    this.toastr.error('Xóa không thành công', '', {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                    });
                } else {
                    this.toastr.success('Xóa thành công', '', {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                    });
                    this.loadData();
                    // this.modalRef2.hide();
                }
            }
        }, error => {
            this.toastr.error(error.message, '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
            });

        });
    }

    clickButton(model: any) {
        this.displayEvent = model;
    }

    eventClick(model: any) {
        this.message = null;
        let period_id = model.event.id;
        let config = {
            backdrop: true,
            ignoreBackdropClick: true,
            keyboard: false
        }
        this.timeService.findPeriod(period_id).subscribe(res => {
            if(!res.error  && res.status == 200) {
                this.modelEvent = res.data;
                this.modalRef = this.modalService.show(this.templateEvent,config);
                this.typeModal = 'edit';
            }
        })
    }
    updateEvent(model: any) {
        model = {
            event: {
                id: model.event.id,
                start: model.event.start,
                end: model.event.end,
                title: model.event.title
                // other params
            },
            duration: {
                _data: model.duration._data
            }
        }
        this.displayEvent = model;
    }

    @HostListener('scroll', ['$event'])
    onLazyload(event:any){
        let totalScroll1 = event.target.offsetHeight + Math.round(event.target.scrollTop) - 1;
        let totalScroll2 = event.target.offsetHeight + Math.round(event.target.scrollTop);
        let totalScroll3 = event.target.offsetHeight + Math.round(event.target.scrollTop) + 1;
        let scrollHeight = event.target.scrollHeight;
        if((totalScroll1 === scrollHeight || totalScroll2 === scrollHeight || totalScroll3 === scrollHeight) && !this.isLoad && (this.totalSchedule >= this.limit || (this.listSchedule.length == 0 && this.totalSchedule >= this.limit))){
            setTimeout(() => {
                this.limit += 15;
                this.isLoad = true;
                this.loadData();
            }, 500);
            
        }
    }

    setPage(page: number) {
        if (page <= this.totalPage) {
            if (page < 1) {
                page = 1;
            }
            if (page != this.currentPage) {
                this.currentPage = page;
                this.detailSchedule(this.current_schedule);
            }
        }
        else {

            page = this.totalPage;
            $('#inputPage').val(page);
            this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
            });
            if (page <= this.totalPage) {
                //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
                if (page < 1) {
                    page = 1;
                }
                if (page != this.currentPage) {
                    this.currentPage = page;
                    this.detailSchedule(this.current_schedule);
                }
            }
        }
    }

    goPage2(toPage: any) {
        toPage = parseInt(toPage);
        if (toPage && toPage > 0) {
            this.setPage(toPage);
        }
    }
}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/pages/admin/icontact/setting/time/time.component.ts